import { Container, styled } from '@mui/material';

export const StyledContainer = styled(Container)(({ theme }) => ({
  position: 'fixed',
  minWidth: 600,
  width: '70%',
  height: '100%',
  top: 0,
  right: 0,
  display: 'flex',
  flexDirection: 'column',
  zIndex: 1101,
  backgroundColor: 'white',
  boxShadow: '0 1px 0 0 rgba(91, 101, 117, 0.15)',
}));
